// src/pages/Moderation/ModerationQueueDetailsPage/model/useQueueDetails.ts
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import {
  approveModerationRequest,
  getModerationFlagsRequest,
  getModerationReportsRequest,
  rejectModerationRequest,
} from 'redux/reducers/moderation/reducer';

import {
  getModerationFlagsSelector,
  getModerationLoaderSelector,
  getModerationReportsSelector,
} from 'redux/reducers/moderation/selectors';

export function useQueueDetails() {
  const { id } = useParams<{ id: string }>();
  const reportId = Number(id);

  const dispatch = useDispatch();
  const loader = useSelector(getModerationLoaderSelector);
  const flags = useSelector(getModerationFlagsSelector);
  const reportsStore = useSelector(getModerationReportsSelector);

  const reportItem = useMemo(() => {
    return reportsStore?.data?.find((r: any) => r?.report?.id === reportId);
  }, [reportsStore, reportId]);

  const [btnActive, setBtnActive] = useState<'approve' | 'reject' | ''>('');

  useEffect(() => {
    if (!reportId) return;

    dispatch(
      getModerationReportsRequest({
        current_page: 1,
        per_page: 10,
        id: reportId,
        has_restriction: true,
      }),
    );
    dispatch(getModerationFlagsRequest());
  }, [dispatch, reportId]);

  const approve = () => {
    setBtnActive('approve');
    dispatch(approveModerationRequest({ ids: [reportId] }));
  };

  const reject = () => {
    setBtnActive('reject');
    dispatch(rejectModerationRequest({ ids: [reportId] }));
  };

  return {
    reportId,
    reportItem,
    flags,
    loader,
    btnActive,
    approve,
    reject,
  };
}
